import { MutableRefObject, useState } from 'react'

import { CursorState } from '@editor/config/constants/cursor'
import { RectangleMeshProps } from '@editor/interfaces/canvas/rectangleMesh'
import { BlueprintEditorTools } from '@editor/pages/projects/blueprint-editor/definitions'
import { RootState, useAppDispatch } from '@editor/store/app'
import { setCursor, setEditingElementId } from '@editor/store/tool'
import { ThreeEvent } from '@react-three/fiber'
import { useSelector } from 'react-redux'

const useAnchorEventHandlers = ({ id }: RectangleMeshProps, editingAnchorRef: MutableRefObject<number | null>) => {
  // Store
  const dispatch = useAppDispatch()
  const selectedTool = useSelector((state: RootState) => state.blueprint.editor.selectedTool)

  // States
  const [hoveredAnchorId, setHoveredAnchorId] = useState<string | null>(null)

  const isSelectedTool = selectedTool === BlueprintEditorTools.Rectangle

  const handleAnchorMouseEnter = (anchorId: string) => (ev: ThreeEvent<MouseEvent>) => {
    ev.stopPropagation()
    setHoveredAnchorId(anchorId)
    dispatch(setCursor(CursorState.GRAB))
  }

  const handleAnchorMouseLeave = (ev: ThreeEvent<MouseEvent>) => {
    ev.stopPropagation()
    setHoveredAnchorId(null)
    dispatch(setCursor(isSelectedTool ? CursorState.CROSSHAIR : CursorState.DEFAULT))
  }

  const handleAnchorMouseDown = (anchorIndex: number) => (ev: ThreeEvent<MouseEvent>) => {
    ev.stopPropagation()
    editingAnchorRef.current = anchorIndex
    dispatch(setEditingElementId(id))
  }

  return {
    hoveredAnchorId,
    handleAnchorMouseEnter,
    handleAnchorMouseLeave,
    handleAnchorMouseDown,
  }
}

export default useAnchorEventHandlers
